// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../reason/next/Next.bs.js");
let React = require("react");
let Loader = require("../uikit/reason/atoms/Loader/Loader.bs.js");
let UserSession = require("../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let ClosedChapterOverlay = require("../reason/common/ClosedChapterOverlay/ClosedChapterOverlay.bs.js");
let TerminatedAccountOverlay = require("../reason/common/TerminatedAccountOverlay/TerminatedAccountOverlay.bs.js");

function AuthenticatedComponentRelay(props) {
  let loaderComponent = props.loaderComponent;
  let redirectPath = props.redirectPath;
  let requiredUserRole = props.requiredUserRole;
  let initState = UserSession.useInitState();
  let router = Next.useRouter();
  React.useEffect(() => {
    switch (initState) {
      case "Unauthenticated" :
        let nextPath = Next.Router.asPath(router);
        let tmp = nextPath === "/" ? undefined : Object.fromEntries([[
              "next",
              nextPath
            ]]);
        router.push({
          pathname: "/login",
          query: tmp
        });
        break;
      case "Agent" :
        if (requiredUserRole === "client") {
          Next.Router.push(Stdlib_Option.getOr(redirectPath, "/"), undefined, undefined, router);
        }
        break;
      case "Client" :
        if (requiredUserRole === "agent") {
          Next.Router.push(Stdlib_Option.getOr(redirectPath, "/client"), undefined, undefined, router);
        }
        break;
    }
  }, [
    initState,
    requiredUserRole,
    Next.Router.pathname(router),
    Next.Router.query(router)
  ]);
  switch (initState) {
    case "Loading" :
      if (loaderComponent !== undefined) {
        return loaderComponent;
      } else {
        return JsxRuntime.jsx(Loader.make, {});
      }
    case "Agent" :
      if (requiredUserRole !== undefined) {
        if (requiredUserRole !== "agent" && requiredUserRole !== undefined) {
          return null;
        }
      } else if (requiredUserRole !== undefined) {
        return null;
      }
      break;
    case "Client" :
      if (requiredUserRole !== undefined) {
        if (requiredUserRole !== "client" && requiredUserRole !== undefined) {
          return null;
        }
      } else if (requiredUserRole !== undefined) {
        return null;
      }
      break;
    default:
      return null;
  }
  let tmp;
  switch (initState) {
    case "Agent" :
      tmp = "Agent";
      break;
    case "Client" :
      tmp = "Client";
      break;
    default:
      tmp = undefined;
  }
  let tmp$1;
  tmp$1 = initState === "Agent" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(TerminatedAccountOverlay.make, {}),
        JsxRuntime.jsx(ClosedChapterOverlay.make, {})
      ]
    }) : null;
  return JsxRuntime.jsxs(UserSession.AuthenticatedStateProvider.make, {
    value: tmp,
    children: [
      tmp$1,
      props.renderWrappedComponent()
    ]
  });
}

let make = AuthenticatedComponentRelay;

exports.make = make;
/* Next Not a pure module */
